<template>
  <div
    class="play-container"
    :style="{'z-index':zIndex}"
    :class="{'play-standard' : !isLive}"
  >
    <template v-if="isLoaded">
      <header :class="['detail-header', {'scrolled': isScrolled}]" ref="detailHeader">
        <div class="inner-wrapper">
          <button type="button" class="btn-detail-back" @click.prevent="goBack">뒤로 돌아가기</button>
        </div>
      </header>

      <PortalTarget name="info-popup" data-scroll-element="true" />

      <div class="play-detail-container" ref="playDetailContainer">
        <GoAppPlayerForLive
          v-if="isLive"
          :content-info="contentInfo"
          :current-section="currentSection"
          :click-player="clickPlayer"
        />
        <GoAppPlayer
          v-else
          :content-info="contentInfo"
          :current-section="currentSection"
          :click-player="clickPlayer"
        />

        <component
          v-if="!isLoading"
          :is="playerDetailComponent"
          :content-info="contentInfo"
          :landing-info="landingInfo"
          :click-player-fn="clickPlayer"
          :notice-list="noticeList"
          :event-list="eventList"
        />
      </div>

      <BottomTabContainer
        v-if="isBottomLoad"
        :content-info="contentInfo"
        :landing-info="landingInfo"
        :key="$route.fullPath"
      />
      <PlayerNoticePopup
        v-if="!isLoading && isNoticePopup"
        :notice-list="noticeList"
      />
    </template>
  </div>
</template>

<script>
import { get, defaultTo } from 'lodash'
import { parseUrl, stringify } from 'query-string'
import { EventBus } from '@/components/eventbus/EventBus'
import { mapGetters, mapMutations } from 'vuex'
import { topTagList } from '@/common/directives'
import { ALREADY_ADULT_VERIFIED, HIDDEN_CONTENT_REDIRECT_TO_HOME, NEED_LOGIN, NEED_PIN_CODE, NEED_VERIFIED, NOT_A_ADULT_CONTENT } from '@/common/constant'
import { STORAGE_CONTENT_FROM_SEARCH, STORAGE_ROUTER_BACK_ADDRESS, STORAGE_ROUTER_HISTORY } from '@/common/resources/const'
import { PATH_NAME_ADULTVERIFY_UNLOCK, PATH_NAME_NOT_FOUND, PATH_NAME_PLAYER } from '@/common/router.const'
import { verifyAdultContentProtectionState, LiveInfoService, MovieInfoService, VodInfoService } from '@/common/api/api.service'
import { popupInsideThePlayerOpen, popupInsideThePlayerClose, enableBodyScroll } from '@/common/util/ui.utils'
import utils from '@/common/util/utils'
import CellList from '@/components/section/template/cell/CellList'
import AllContentList from '@/components/play/bottom-tab/AllContentList'
import BottomTabContainer from '@/components/play/bottom-tab/BottomTabContainer'
import LnbWrapper from '@/components/lnb/LnbWrapper'
import PlayerNoticePopup from '@/components/play/PlayerNoticePopup'
import MainHeader from '@/components/header/template/MainHeader'
import GoAppPlayer from '@/components/play/GoAppPlayer'
import GoAppPlayerForLive from '@/components/play/GoAppPlayerForLive'

export default {
  name: 'PlayerDetail',
  components: {
    GoAppPlayer,
    LnbWrapper,
    MainHeader,
    BottomTabContainer,
    AllContentList,
    CellList,
    MoviePlayerDetailInfo: () => import('@/components/play/MoviePlayerDetailInfo'),
    VodPlayerDetailInfo: () => import('@/components/play/VodPlayerDetailInfo'),
    LivePlayerDetailInfo: () => import('@/components/play/LivePlayerDetailInfo'),
    PlayerNoticePopup,
    GoAppPlayerForLive
  },
  directives: {
    topTagList
  },
  data () {
    return {
      isLoaded: false,
      contentInfo: {},
      landingInfo: {},
      eventList: [],
      zIndex: 3000,
      currentSection: '',
      isLoading: false,
      isBottomLoad: true,
      noticeList: [],
      isNoticePopup: false,
      hasBeforePageInfo: false,
      isScrolled: false,
      backRouteAddress: ''
    }
  },
  methods: {
    ...mapMutations(['showSearch', 'showAdultCheck', 'hideAdultCheck']),
    goBack () {
      this.$router.back()
    },
    getBackRouteAddress () {
      const latestAddress = (JSON.parse(sessionStorage.getItem(STORAGE_ROUTER_HISTORY)) || [])[1]
      if (!latestAddress) return
      const isPickUpAbleAddress = latestAddress.match(/^((?!\/(player|voucher|login|adultverify|event)).)*$/gi)
      if (isPickUpAbleAddress) sessionStorage.setItem(STORAGE_ROUTER_BACK_ADDRESS, latestAddress)
    },
    removeEvent () {
      EventBus.$off('on-exit')
      EventBus.$off('on-enter')
    },
    async verifiedAdultContent (contentInfo) {
      const targetAge = Number(contentInfo.seasontargetage || contentInfo.targetage || '0')
      const res = await utils.common.verifyAdult(targetAge)
      const { query } = parseUrl(this.$route.fullPath)
      delete query.referer
      switch (res) {
        case NOT_A_ADULT_CONTENT:
        case ALREADY_ADULT_VERIFIED:
          this.isBottomLoad = true
          break
        case HIDDEN_CONTENT_REDIRECT_TO_HOME:
          await this.$router.replace('/')
          break
        case NEED_LOGIN:
          await this.$router.replace(`/login?referer=${this.$route.path}?${stringify(query)}&adult=y`)
          break
        case NEED_PIN_CODE:
          await this.$router.replace({
            name: PATH_NAME_ADULTVERIFY_UNLOCK,
            query: {
              referer: this.getBeforeEnterPlayerPath
            },
            params: {
              action: async ({ pincode, resetFn, successFn }) => {
                try {
                  const result = await verifyAdultContentProtectionState(pincode)
                  const { resultcode } = result.data
                  if (resultcode === '200') {
                    successFn()
                  }
                } catch (e) {
                  if (typeof resetFn === 'function') {
                    resetFn()
                  }
                }
              },
              enter: this.$route.fullPath
            }
          })
          break
        case NEED_VERIFIED:
          this.isBottomLoad = false
          EventBus.$once('on-exit', (section, uiCode) => {
            this.$route.query.adult = 'y'
            this.hideAdultCheck()
            this.removeEvent()
            this.isLoading = true
            this.isLoaded = false
            this.$router.back()
          })
          EventBus.$once('on-enter', () => {
            this.isBottomLoad = true
            this.loadedFn()
            this.hideAdultCheck()
            this.removeEvent()
          })
          this.showAdultCheck()
          break
      }
    },
    async loadContent (route) {
      const section = this.currentSection.toUpperCase()
      if (this.isLoading) return

      this.isLoading = true
      switch (section) {
        case 'MOVIE' :
          await this.loadDataMovie(route)
          break

        case 'VOD' :
          await this.loadDataVOD(route)
          break

        case 'LIVE' :
          await this.loadDataLive(route)
          break

        default :
          await this.$router.push({ name: PATH_NAME_NOT_FOUND })
      }

      await this.handleScrollFn()
    },
    addAutoPlayParameter (url) {
      const autoPlayFlag = get(this.$route, 'query.autoplay', 'n')
      return autoPlayFlag.toLowerCase() === 'y' ? url + '&autoplay=y' : url
    },
    clickPlayer () {
      const section = this.currentSection.toUpperCase()
      let url = ''
      switch (section) {
        case 'MOVIE':
          url = `player/movie?movieid=${this.contentInfo.movieid}`
          break
        case 'VOD':
          url = `player/vod?contentid=${this.contentInfo.contentid}`
          break
        case 'LIVE':
          url = `player/live?channelid=${this.contentInfo.channelid}`
          break
      }
      url = this.addAutoPlayParameter(url)
      utils.common.checkInstallApps(url)
    },
    routerBack () {
      this.hasBeforePageInfo ? this.$router.back() : this.$router.push('/')
    },
    async loadDataMovie (route) {
      // 영화 데이터 호출 로직 (metaInfo 를 호출 한 뒤 EVENT : 무조건 호출, NOTICE: 무조건 호출)
      const movieID = route.query.movieid

      // 상세 metaInfo 호출
      const getMovieMetaInfo = async (movieID) => {
        const { data } = await MovieInfoService.getMovieMetaInfo({ movieID }, (error) => alert(error.response.data.resultmessage))
        const movieId = get(data, 'movieid', '') || movieID

        await this.verifiedAdultContent(data)
        await getMovieEventInfo(movieID)

        this.contentInfo = data
        return { movieId }
      }

      // movie event 호출
      const getMovieEventInfo = async (movieID) => {
        const { data } = await MovieInfoService.getEventBanner({ movieID })
        this.eventList = get(data, 'list', [])
      }

      // notice 호출
      const getNoticeInfo = async (movieId) => {
        const { data } = await MovieInfoService.getContentNoticeInfo({ movieId })
        this.noticeList = get(data, 'list', [])
        if (this.isBottomLoad) this.loadedFn()
      }

      try {
        const { movieId } = await getMovieMetaInfo(movieID)
        await getNoticeInfo(movieId)
      } catch (e) {
        console.error(`${e.name} ${e.message}`)
        this.routerBack()
      }
    },
    async loadDataVOD (route) {
      // VOD 데이터 호출 로직 ( landingInfo, metaInfo, noticeInfo 순으로 노출)
      const programID = get(route, ['query', 'programid'], '')
      const contentID = get(route, ['query', 'contentid'], '')
      const landingContentHistory = (get(route, 'query.landing', '') || get(route, 'query.history', '')) || 'all'

      // landingInfo 호출
      const setLandingInfo = async (programID, contentID) => {
        const { data } = await VodInfoService.getContentLandingInfo({ programID: programID, contentID: contentID, history: landingContentHistory })
        const { content_id: contentId = '' } = data
        this.landingInfo = data
        return { contentId }
      }

      // event 호출
      const getVodEventInfo = async (programID) => {
        const { data } = await VodInfoService.getEventBanner({ programID })
        this.eventList = get(data, 'list', [])
      }

      // metaInfo 호출
      const setVodMetaInfo = async (contentID) => {
        const { data } = await VodInfoService.getVodMetaInfo({ contentID })
        const programId = get(data, 'programid', '') || programID

        await this.verifiedAdultContent(data)
        await getVodEventInfo(programId)

        this.contentInfo = data
        return { programId }
      }

      // notice 호출
      const setNoticeInfo = async (programId) => {
        const { data } = await VodInfoService.getContentNoticeInfo({ programID: programId })
        this.noticeList = get(data, 'list', [])
        if (this.isBottomLoad) this.loadedFn()
      }

      try {
        const { contentId } = await setLandingInfo(programID, contentID)
        const { programId } = await setVodMetaInfo(contentId)
        await setNoticeInfo(programId)
      } catch (e) {
        console.error(`${e.name} ${e.message}`)
        this.routerBack()
      }
    },
    loadedFn () {
      this.isLoaded = true
      this.isLoading = false
    },
    async loadDataLive (route) {
      const channelID = route.query.channelid

      try {
        const { data } = await LiveInfoService.getLiveMetaInfo({ channelID })
        await this.verifiedAdultContent(data)
        this.contentInfo = data
        if (!this.isBottomLoad) return
        this.isLoaded = true
        this.isLoading = false
      } catch (e) {
        console.error(`${e.name} ${e.message}`)
        this.routerBack()
      }
    },
    handleScrollFn () {
      const playDetailContainer = this.$refs.playDetailContainer

      if (!playDetailContainer) return // 성인인증 페이지 랜딩일 경우 리턴

      const observer = new IntersectionObserver(([e]) => {
        this.isScrolled = !e.isIntersecting
      }, {
        threshold: 0
      })
      observer.observe(playDetailContainer)
    }
  },
  computed: {
    ...mapGetters(['getBeforeEnterPlayerPath', 'isVisibleAdultCheckView']),
    playerDetailComponent () {
      return this.currentSection ? `${this.currentSection}-player-detail-info` : null
    },
    isLive () {
      // fixme LIVE 분기 : 이후 라이브 상세 개편 시 -> 제거 필요  22/11/16 (라이브 배경 이미지, 라이브 전용 클래스, 라이브 goAppPlayer 분기 위해 필요)
      return this.currentSection === 'live'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.hasBeforePageInfo = get(from, 'name', '') !== null
    })
  },
  created () {
    // current section : vod / movie
    this.currentSection = this.$route.params.section
    // INFO: 추천 목록에서 다른 회차나 프로그램이 19금일경우에 뒤로가기하면 그대로 남아 있는 경우가 있어서 create할때 vuex에 값이 있으면 초기화 한다.
    if (this.isVisibleAdultCheckView) {
      this.hideAdultCheck()
    }
    if (get(this.$route, ['query', 'search'], 'n').toLowerCase() === 'y') {
      this.zIndex = 3001
    }
    if (get(this.$route, 'query.isNotice', '') === 'y') {
      popupInsideThePlayerOpen()
      this.isNoticePopup = true
    } else {
      popupInsideThePlayerClose()
      this.isNoticePopup = false
    }
    this.getBackRouteAddress()
  },
  mounted () {
    this.loadContent(this.$route)
    enableBodyScroll()
  },
  updated () {
    this.$nextTick(function () {
      let interval = setInterval(function () {
        const player = document.getElementById('player')
        if (!player) return
        const boundingRect = player.getBoundingClientRect()
        player.style.maxHeight = boundingRect.height
        clearInterval(interval)
      }, 50)
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.isVisibleAdultCheckView) {
      this.hideAdultCheck()
    }
    if (to.name !== PATH_NAME_PLAYER) {
      sessionStorage.setItem(STORAGE_CONTENT_FROM_SEARCH, 'n')
    }
    next()
  },
  watch: {
    $route (to, from) {
      this.currentSection = get(to, ['params', 'section'], '')
      this.loadContent(to)
    }
  }
}
</script>

<style scoped>
  header {
    width: 100%;
  }
  .play-container.chrome-fixed{
    position: fixed;
    height: 100vh;
    overflow: hidden;
  }
  .player {
    position: relative;
    overflow: hidden;
    width: 100%;
    background-color: black;
    top: 0;
    left: 0;
    padding-top: 56.25%;
    max-height: 210px;
  }
  .player-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%
  }

  /*.player-image.movie {*/
  /*  position: absolute;*/
  /*  top: 0;*/
  /*  left: 0;*/
  /*  width: auto;*/
  /*  height: 100%;*/
  /*  margin-left: 30.4%;*/
  /*}*/
  .player-back-btn {
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 4px;
    left: 4px;
    width: 36px;
    height: 36px;
    z-index: 100;
  }
  /*.play-btn {*/
  /*  position: absolute;*/
  /*  top: 50%;*/
  /*  left: 50%;*/
  /*  width: 36px;*/
  /*  height: 36px;*/
  /*  margin-left: -18px;*/
  /*  margin-top: -18px;*/
  /*}*/

  .play-event-container{
    margin-top: 20px;
  }

  .player-notice + .play-event-container{
    margin-top: 0;
  }

  .play-event-container a{
    display: block;
  }

  .play-event-container a img{
    display: block;
    width: 100%;
    max-width: 375px;
    margin: 0 auto;
  }

  @media screen and (min-width: 768px){
    .player{
      position: sticky;
      top: 0;
      z-index: 10;
    }
  }
</style>
